// A request, carried in the router's location state, for the home page to start today's review as soon as it
// opens: `navigate("/", { state: START_DAILY_REVIEW_ON_ARRIVAL_LOCATION_STATE })`. The home daily review card
// (TodaysReviewComponent) answers it through the same code as its own "start daily review" button, so the
// review is prepared, recorded and opened exactly as from home. A learner without a review to do simply
// arrives on home. The card takes the request out of the history entry as soon as home opens and acts on it
// only for that one arrival: Back, Forward or a reload onto home never start a review
// (TodaysReviewComponent.startOnArrival.test.tsx holds the order of events).
export const START_DAILY_REVIEW_ON_ARRIVAL_LOCATION_STATE = { shouldStartDailyReviewOnArrival: true } as const;

export function isStartDailyReviewOnArrivalRequested(locationState: unknown): boolean {
  return (
    typeof locationState === "object" &&
    locationState !== null &&
    (locationState as { shouldStartDailyReviewOnArrival?: unknown }).shouldStartDailyReviewOnArrival === true
  );
}
